<template>

  <div class="app-container" v-if="canList">
    <div class="filter-container">
      <el-input style="width: 200px;" class="filter-item input"
                placeholder="级别名字"
                v-model="listQuery.name">
      </el-input>

      <el-select @change='handleFilter' clearable class="filter-item input" style="width: 130px"
                 v-model="listQuery.type"
                 placeholder="类型">
        <el-option v-for="(item,index) in  typeOptions" :key="item" :label="item" :value="index">
        </el-option>
      </el-select>

      <div style="display: inline-block">

        <el-button style="margin-left: 10px;" class="filter-item" type="primary" v-waves icon="el-icon-search"
                   @click="handleFilter">查找
        </el-button>
        <el-button class="filter-item" style="margin-left: 10px;" @click="handleCreate" type="primary"
                   v-if="canSave" icon="el-icon-edit">添加
        </el-button>
        <!--                <el-button class="filter-item" type="primary" :loading="downloadLoading" v-waves icon="el-icon-download"-->
        <!--                           @click="handleDownload">导出-->
        <!--                </el-button>-->
      </div>
    </div>

    <el-table :key='tableKey' :data="list" v-loading="listLoading" border fit highlight-current-row
              style="width: 100%;min-height:1000px;">
      <el-table-column align="center" label="序号">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="级别名字">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="级别权重">
        <template slot-scope="scope">
          <span>{{ scope.row.lv }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="升级金额">
        <template slot-scope="scope">
          <span>{{ scope.row.amount }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="利润">
        <template slot-scope="scope">
          <span>{{ scope.row.sale }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="类型">
        <template slot-scope="scope">
                                                <span>

                         <el-tag :type="tagTypes[scope.row.type]">     {{ typeOptions[scope.row.type] }}</el-tag>

                        </span>
        </template>
      </el-table-column>

      <el-table-column align="center" label="操作" width="230" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="primary" v-if="canUpdate" size="mini" @click="handleUpdate(scope)">编辑</el-button>
          <el-button v-if="canSave" size="mini" type="danger"
                     @click="handleDelete(scope)">删除
          </el-button>
        </template>
      </el-table-column>

    </el-table>

    <div class="pagination-container">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit"
                     layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>

    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
      <el-form :rules="rules" ref="dataForm" :model="temp" label-position="left" label-width="120px"
               style='width: 450px; margin-left:50px;'>
        <el-form-item label="级别名字" prop="name">
          <el-input v-model="temp.name"></el-input>
        </el-form-item>
        <el-form-item label="级别权重" prop="lv">
          <el-input v-model="temp.lv"></el-input>
        </el-form-item>
        <el-form-item label="升级金额" prop="amount">
          <el-input v-model="temp.amount"></el-input>
        </el-form-item>
        <el-form-item label="利润" prop="amount">
          <el-input v-model="temp.sale"></el-input>
        </el-form-item>
        <el-form-item label="限制支付" prop="" :show-all-levels="false">
          <el-select v-model="temp.limitPayWay" placeholder="是否限制">
            <el-option
                v-for="(item,index) in  limitPayWay"
                :key="index"
                :label="item"
                :value="index">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型" prop="status">
          <el-select class="filter-item" v-model="temp.type" placeholder="类型">
            <el-option v-for="(item,index) in  typeOptions" :key="item" :label="item"
                       :value="index">
            </el-option>
          </el-select>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialogForm">取消</el-button>
        <el-button v-if="dialogStatus=='create'" type="primary" @click="createData">确认</el-button>
        <el-button v-else type="primary" @click="updateData">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<style type="stylus">
.filter-container {
  /*padding-bottom: 20px;*/
}

.filter-item {
  margin-bottom: 10px;
}

.filter-item.input {
  /*line-height: 60px*/
  margin-right: 10px;
}
</style>

<script>
import {list, save, update, remove} from '@/api/level'
import waves from '@/directive/waves' // 水波纹指令


import {mapGetters} from 'vuex'
import {hasAuth} from '@/utils/auth'

export default {
  name: 'test',
  directives: {
    waves
  },
  data() {
    return {
      limitPayWay: ["不限制", "限制"],
      tableKey: 0,
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 20,
        order: 'lv desc'
        ,
        name: null
        ,
        lv: null
        ,
        amount: null
        ,
        type: null
      },
      typeOptions: ["开放", "内部"],
      tagTypes: ['info', '', 'warning', 'danger', 'warning'],
      temp:
          {
            id: null, name: null, lv: null, amount: null, type: null,  limitPayWay:null
          }
      ,
      dialogFormVisible: false,
      dialogStatus
  :
    '',
        textMap
  :
    {
      update: '修改',
          create
    :
      '新增'
    }
  ,
    rules:
    {
      name : [
        {
          required: false, message
    :
      '必填字段', trigger
    :
      'change'
    }
    ]
    ,
      lv : [
        {
          required: false, message
    :
      '必填字段', trigger
    :
      'change'
    }
    ]
    ,
      amount : [
        {
          required: false, message
    :
      '必填字段', trigger
    :
      'change'
    }
    ]
    ,
      type : [
        {
          required: false, message
    :
      '必填字段', trigger
    :
      'blur'
    }
    ]
    }
  ,
    downloadLoading: false,
        qData
  :
    {
      token: '',
          key
    :
      ''
    }
  }
  },
  created() {
    this.getList()
  },
  computed: {
    ...mapGetters([
      'perms'
    ]),
    canSave() {
      return hasAuth(this.perms, 'level:save')
    },
    canDelete() {
      return hasAuth(this.perms, 'level:delete')
    },
    canUpdate() {
      return hasAuth(this.perms, 'level:update')
    },
    canList() {
      return hasAuth(this.perms, 'level:list')
    }
  },
  methods: {
    getList() {
      this.listLoading = true
      list(this.listQuery).then(response => {
        this.list = response.data.list
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    handleModifyStatus(row, status) {
      this.$message({
        message: '操作成功',
        type: 'success'
      })
      row.status = status
    },
    beforeFormShow(row) {
      this.resetTemp(row) // 更新数据
      // 存在图片

    },
    afterFormShow(row) {

    },
    beforeFormCommit() {
    },
    resetTemp(row) {

      this.temp = {}
      if (row) {
        this.temp = Object.assign({}, row) // copy obj
      }

    },
    handleCreate() {
      this.beforeFormShow()
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.afterFormShow()
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleDelete(scope) {
      this.index = scope.$index
      // this.beforeFormShow(scope.row)
      // this.temp = Object.assign({}, row) // copy obj
      this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // this.$message({
        //   type: 'success',
        //   message: '删除成功!'
        // })
        this.deleteData()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    createData() {
      this.$refs['dataForm'].validate((valid) => {
            if (valid) {
              this.beforeFormCommit()
              save(this.temp).then(res => {
                this.temp = res.data
                this.list.unshift(this.temp)
                this.closeDialogForm()
                this.$notify({
                  title: '成功',
                  message: '创建成功',
                  type: 'success',
                  duration: 2000
                })
              })
            }
          }
      )
    },
    deleteData() {
      // const ids = [this.temp.id]
      const ids = [this.list[this.index].id]
      remove({ids: ids}).then(res => {
        // 从当前队列中移除
        this.list.splice(this.index, 1)
        this.$notify({
          title: '成功',
          message: '删除成功',
          type: 'success',
          duration: 2000
        })
      })
    },
    handleUpdate(scope) {
      this.index = scope.$index
      this.beforeFormShow(scope.row)
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    updateData() {
      this.$refs['dataForm'].validate((valid) => {
            if (valid) {
              this.beforeFormCommit()
              update(this.temp).then(() => {
                this.list.splice(this.index, 1, this.temp)
                this.closeDialogForm()
                this.$notify({
                  title: '成功',
                  message: '更新成功',
                  type: 'success',
                  duration: 2000
                })
              })
            }
          }
      )
    },
    closeDialogForm() {
      this.dialogFormVisible = false
    },
    handleDownload() {
      this.downloadLoading = true
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = [
          '序号'
          ,
          '级别名字'
          ,
          '级别权重'
          ,
          '升级金额'
          ,
          '类型'
        ]
        const filterVal = ['id'
          , 'name'
          , 'lv'
          , 'amount'
          ,
          'type'
        ]
        const data = this.formatJson(filterVal, this.list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: 'table-list'
        })
        this.downloadLoading = false
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
            return v[j]
          }
      ))
    },
  }
}
</script>
